(function () {
  'use strict';

  angular.module('wsLrs.controllers').config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/signin', {
      templateUrl: 'modules/outside/signin/signin.html',
      controller: 'SignInCtrl',
      resolve: {
        "orgContext": ["OrganizationContext", function (OrganizationContext) {
          return OrganizationContext.load();
        }]
      }
    });
  }]).controller('SignInCtrl', ['$scope', '$window', '$routeParams', '$http', 'Config', 'orgContext', 'Utils', function ($scope, $window, $routeParams, $http, Config, orgContext, Utils) {
    var wsConfig = Config.get(),
      externalLoginToken = Utils.getQueryVariable("token"),
      externalXsrfToken = Utils.getQueryVariable("xsrf"),
      externalLoginError = Utils.getQueryVariable("error") ? Utils.getQueryVariable("error").replace(/\+/g, " ") : null;
    $scope.wsConfig = wsConfig;
    $scope.showLogin = false;
    $scope.loginFormSubmitted = null;
    $scope.googleLoginRequired = wsConfig.googleLoginRequired === true;

    // If this flag is set, it means we're logged out of saml and are going back to WS login page. We
    // won't automatically invoke the SAML login sequence if this is set.  And we won't show the user/pass.
    if ($window.location.search && $window.location.search.indexOf("samlLogout=true") >= 0) {
      $scope.samlLogout = true;
    }
    function loginSuccess(response) {
      $scope.loginFormSubmitted = false;
      return response;
    }
    function loginError(response) {
      $scope.loginFormSubmitted = false;
      $scope.signinError = response.data.message;
    }

    // User submitted login form
    $scope.submitLoginForm = function (username, password) {
      if ($scope.samlLogout) {
        $window.location.href = $scope.samlLoginUrl;
        return;
      }
      $scope.loginFormSubmitted = true;
      var publicAccessEmail = null;
      if (wsConfig.enablePublicLogin === true && username === wsConfig.publicLoginUsername) {
        publicAccessEmail = password;
        password = wsConfig.publicLoginPassword;
      }
      $scope.tryLogin(username, password).then(function (response) {
        if (publicAccessEmail) {
          $http({
            method: "POST",
            url: wsConfig.apiUrl + "/demo/log-public-access",
            data: $.param({
              email: publicAccessEmail
            }),
            headers: {
              "Authorization": "Basic " + Utils.base64encode(username + ":" + password),
              "Content-Type": "application/x-www-form-urlencoded"
            }
          });
        }
        return loginSuccess(response);
      }, loginError);
    };

    // If auto login indicated, try that
    if ($routeParams.auto === "true") {
      $scope.tryLogin($routeParams.username, $routeParams.password).then(loginSuccess, loginError);
      return;
    }

    // If we're coming back from external login, use the access token to login
    if (externalLoginToken) {
      $scope.tryLoginWithAuth("Bearer " + externalLoginToken, externalXsrfToken).then(loginSuccess, loginError);
      return;
    }

    // If we're coming back from external login, with error, show it
    if (externalLoginError) {
      $scope.externalLoginError = "There was an error logging in from the external system: " + externalLoginError;
      return;
    }

    // If we're under an org context that has specified explicit identity providers...
    if (orgContext && orgContext.settings.identityProviders.length > 0) {
      var idProviders = orgContext.settings.identityProviders;
      if (!_.isEmpty(idProviders)) {
        // Should we figure out how to support multiple identity providers?
        // So far, nobody has asked for it.

        // If saml provider specified, send the user right into that login
        if (idProviders[0] === "saml") {
          if (!$scope.samlLogout) {
            $window.location.href = $scope.getExternalLoginUrl(idProviders[0], orgContext.id);
            return;
          } else {
            $scope.samlLoginUrl = $scope.getExternalLoginUrl(idProviders[0], orgContext.id);
          }
        } else if (idProviders[0] === "ipaas") {
          if (!$scope.ipaasLogout) {
            $window.location.href = $scope.getExternalLoginUrl(idProviders[0], orgContext.id);
            return;
          } else {
            $scope.ipaasLoginUrl = $scope.getExternalLoginUrl(idProviders[0], orgContext.id);
          }

          // If it's Google login based, let them see and click the Google link, rather than
          // just redirect them directly (which might come off as sketchy to the user).
        } else if (idProviders[0] === "google") {
          $scope.googleLoginRequired = true;
        }
      }
    }

    // If we ended up here because of an unauthorized request, it probably
    // means a session expired. Tell the user here.
    if ($window.location.search && $window.location.search.indexOf("reason=unauthorized") >= 0) {
      $scope.signinError = "It appears your session has expired. Please sign in to continue.";
    }

    // Only show login if they are not authenticated
    $scope.showLogin = true;
  }]);
})();
